export default __webpack_public_path__ + "static/media/courtshoes_medium.c02ea60e.jpg";